import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Elasticsearch = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="Elasticsearch "
    height={height}
    width={width}
    title="Elasticsearch logo"
    titleId="elasticsearch-logo-title"
    viewBox="0 0 256 286"
    {...props}
  >
    <path
      d="m14.3443 80.1733h189.206c20.851 0 39.47-9.561 51.963-24.487-26.06-33.851-66.961-55.686-112.983-55.686-56.352 0-105.054 32.711-128.186 80.173"
      fill="#f0bf1a"
    />
    <path
      d="m187.5152 102.4438h-181.76c-3.722 12.721-5.755 26.163-5.755 40.086 0 13.924 2.033 27.367 5.755 40.087h181.76c21.825 0 40.087-17.816 40.087-40.087 0-22.27-17.816-40.086-40.087-40.086"
      fill="#07a5de"
    />
    <path
      d="m255.9996 228.7548c-12.414-14.591-30.883-23.868-51.559-23.868h-190.096c23.132 47.463 71.834 80.173 128.185 80.173 46.306 0 87.436-22.097 113.47-56.305"
      fill="#3ebeb0"
    />
    <path
      d="m5.7555 102.4438c-3.723 12.721-5.755 26.163-5.755 40.086 0 13.924 2.032 27.367 5.755 40.087h118.958c3.118-12.026 4.899-25.388 4.899-40.087 0-14.698-1.781-28.06-4.899-40.086z"
      fill="#231f20"
    />
    <path
      d="m70.8199 19.1528c-24.053 14.253-44.096 35.632-56.567 61.021h105.116c-10.69-24.498-27.615-44.986-48.549-61.021"
      fill="#d7a229"
    />
    <path
      d="m75.274 268.1347c20.488-16.48 36.968-38.305 47.213-63.248h-108.234c13.362 26.725 34.742 48.995 61.021 63.248"
      fill="#019b8f"
    />
  </SvgIcon>
);
